import styled from "styled-components";
import Layout from "../../../components/custom/Layout";
import VirtualTable from "../../../components/custom/VirtualTable";
import { useAppContext } from "../../../context";
import useData, { AddScreenerData } from "./useData";
import ActionIcon from "../../../components/custom/ActionIcon";
import { useState } from "react";
import ModalAddScreener from "./ModalAddScreener";
import ModalViewScreener from "./ModalViewScreener";
import { notify } from "../../../utils";
import { ITsaScreener } from "../../../globals/interfaces";

export default function TsaScreeners() {

    const { user } = useAppContext();
    const { 
            screeners, 
            addScreener, 
            deleteScreener, 
            selectedScreener, 
            setSelectedScreener 
    } = useData(user.s_unit, user.s_email);
    const [modalAddScreener, setModalAddScreener] = useState(false);
    const [modalViewScreener, setModalViewScreener] = useState(false);

    const launchAddScreener = () => {
        setModalAddScreener(true);
    }

    const handleAddScreener = async (data: AddScreenerData) => {
        const result = await addScreener(data);
        if (result) {
            notify('Screener Added');
            setModalAddScreener(false);
            setModalViewScreener(true);
        }
    }

    const viewScreener = (screener: ITsaScreener) => {
        setSelectedScreener(screener);
        setModalViewScreener(true);
    }

    return (
        <Layout>
            <FlexContainer>
                <h4>Screeners:</h4>
                <ActionIcon
                    type={'add'}
                    onClick={() => launchAddScreener()}
                />
            </FlexContainer>
            <VirtualTable
                data={screeners}
                mapping={[{
                    name: 'Email',
                    value: 'email'
                }, {
                    name: 'Barcode Number',
                    value: 'unit'
                }, {
                    name: 'Created By',
                    value: 'createdBy'
                }, {
                    name: 'Created At',
                    value: 'createdAt'
                }]}
                handleClick={(screener: ITsaScreener) => viewScreener(screener)}
            />
            <ModalAddScreener
                modal={modalAddScreener}
                setModal={setModalAddScreener}
                handleAddScreener={handleAddScreener}
                user={user}
            />
            <ModalViewScreener
                modal={modalViewScreener}
                setModal={setModalViewScreener}
                selectedScreener={selectedScreener}
                deleteScreener={deleteScreener}
            />
        </Layout>
    );
}

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;